import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Keep in sync with SCHEDULER_TIMEZONE — salon wall-clock, not the browser. */
export const REGISTER_LOCAL_TIMEZONE = "America/New_York";
export const OVERNIGHT_CLOSEOUT_HOUR = 8;

/**
 * Prompt closeout only after 8:00 AM local on the calendar day after the
 * register was opened. Same-day opens (even before 8am) do not prompt until
 * the following morning.
 */
export function shouldPromptOvernightCloseout({
  isOpen,
  openedAt,
  now = new Date(),
  timeZone = REGISTER_LOCAL_TIMEZONE,
  hour = OVERNIGHT_CLOSEOUT_HOUR,
} = {}) {
  if (!isOpen || !openedAt) return false;

  const openedLocal = dayjs(openedAt).tz(timeZone);
  if (!openedLocal.isValid()) return false;

  const promptAt = openedLocal
    .startOf("day")
    .add(1, "day")
    .hour(hour)
    .minute(0)
    .second(0)
    .millisecond(0);

  return !dayjs(now).tz(timeZone).isBefore(promptAt);
}
